import React from "react";
import logo from "../../assets/img/loader.png";
import { useParams, useNavigate } from "react-router-dom";
import { Button, Card, CardHeader, CardBody, CardFooter, Form, Input, InputGroupAddon, InputGroupText, InputGroup, Container, Col, Row } from "reactstrap";
import { resetPassword } from "../../services/userService";
import { toastBigError, toastError, toastInfo } from "../utils/toasts";
import { usePageLoading } from "hooks/usePageLoading";

const ResetPassword = (props) => {
  const doneLoading = usePageLoading(props);
  const [data, setData] = React.useState({
    password: "",
    confirm: "",
  });
  const [sent, setSent] = React.useState(false);
  const [firstFocus, setFirstFocus] = React.useState(false);
  const params = useParams();
  const navigate = useNavigate();

  React.useEffect(() => {
    document.body.classList.add("login-page");
    // document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    doneLoading(); // no hay datos que traer
    return function cleanup() {
      document.body.classList.remove("login-page");
      // document.body.classList.remove("sidebar-collapse");
    };
  }, []);

  const doReset = async (event) => {
    event.preventDefault();
    if (data.password !== data.confirm) toastBigError("Las constraseñas no coinciden");
    else {
      const success = await resetPassword(params.id, params.token, data);
      if (success.data.toUpperCase().includes("ERROR")) toastError(success.data);
      else {
        toastInfo(success.data);
        setSent({ sent: true });
      }
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      doReset(event);
    }
  };
  const handleChange = ({ currentTarget: input }) => {
    const newData = { ...data };
    newData[input.name] = input.value;
    setData(newData);
  };

  const goHome = () => {
    localStorage.removeItem("token");
    navigate("login");
    // history.push({
    //   pathname: "/login",
    //   state: {},
    // });
  };

  return (
    <>
      <div className="page-header header-filter">
        <div
          className="page-header-image"
          style={{
            backgroundImage: "url(" + require("assets/img/landing-background.png") + ")",
          }}
        ></div>
        <div className="content">
          <Container>
            <Row>
              <Col className="ml-auto mr-auto" md="5">
                <Card className="card-login card-plain">
                  <Form action="" className="form" method="">
                    <CardHeader className="text-center">
                      <div>
                        <img alt="..." src={logo} style={{ height: "150px", width: "150px" }}></img>
                      </div>
                    </CardHeader>
                    {!sent && (
                      <>
                        <CardBody>
                          <Row>
                            <Col md="12" className="mb-2">
                              <h4>Cambiar contraseña</h4>
                              <p>Ingrese su e-mail para recibir las instrucciones para recuperar su contraseña</p>
                            </Col>
                          </Row>
                          <InputGroup className={"no-border input-lg" + (firstFocus ? " input-group-focus" : "")}>
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText>
                                <i className="fas fa-key"></i>
                              </InputGroupText>
                            </InputGroupAddon>
                            <Input
                              autoFocus
                              id="password"
                              name="password"
                              placeholder="Ingrese nueva contraseña"
                              type="password"
                              onChange={handleChange}
                              onFocus={() => setFirstFocus(true)}
                              onBlur={() => setFirstFocus(false)}
                              value={data.password}
                            ></Input>
                          </InputGroup>
                          <InputGroup className={"no-border input-lg" + (firstFocus ? " input-group-focus" : "")}>
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText>
                                <i className="fas fa-key"></i>
                              </InputGroupText>
                            </InputGroupAddon>
                            <Input
                              autoFocus
                              id="confirm"
                              name="confirm"
                              placeholder="Confirme nueva contraseña"
                              type="password"
                              onChange={handleChange}
                              onFocus={() => setFirstFocus(true)}
                              onBlur={() => setFirstFocus(false)}
                              onKeyPress={handleKeyPress}
                              value={data.confirm}
                            ></Input>
                          </InputGroup>
                        </CardBody>
                        <CardFooter className="text-center">
                          <Button block className="btn-round btn-arhock" onClick={(event) => doReset(event)} size="lg">
                            Cambiar Contraseña
                          </Button>
                        </CardFooter>
                      </>
                    )}
                    {sent && (
                      <>
                        <CardBody>
                          <Row>
                            <Col md="12" className="mb-2">
                              <h4>Contraseña Restablecida</h4>
                              <p>Contraseña restablecida correctamente. Ya puede ingresar al sistema</p>
                            </Col>
                          </Row>
                        </CardBody>
                        <CardFooter className="text-center">
                          <h6>
                            <a className="link footer-link clickable" onClick={goHome}>
                              Ingresar
                            </a>
                          </h6>
                        </CardFooter>
                      </>
                    )}
                  </Form>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </>
  );
};

export default ResetPassword;
